import { render } from "./StockProfileTable.vue?vue&type=template&id=6352095e"
import script from "./StockProfileTable.vue?vue&type=script&lang=js"
export * from "./StockProfileTable.vue?vue&type=script&lang=js"

import "./StockProfileTable.vue?vue&type=style&index=0&id=6352095e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__